import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import ToastModule from '@modules/ToastModule';

export class BrowserNotificationsModule extends AppModule {
  override load(): void {
    this.requestNotificationPermission();
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  public showBrowserNotification = (
    title: string,
    options?: NotificationOptions,
  ) => {
    if (Notification.permission === 'granted') {
      const notification = new Notification(title, options);

      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    }
  };

  private handleBeforeUnload = (event: BeforeUnloadEvent) => {
    let showDefaultDialog = false;

    if (SoftPhoneModule.isInCall()) {
      this.app.logger.info('app unloaded while in call');
      // Recommended to display the browser confirmation dialog
      event.preventDefault();

      showDefaultDialog = true;

      ToastModule.showToast({
        title:
          'Warning: Closing or reloading Contact Center Pro will drop your current call.',
        status: 'warning',
      });
    }

    SoftPhoneModule.callControl.disconnect();

    if (showDefaultDialog) {
      // display the browser confirmation dialog
      event.preventDefault();

      // display the confirmation dialog for legacy support, e.g. Chrome/Edge < 119
      event.returnValue = true;
    }
  };

  private requestNotificationPermission = async () => {
    if (Notification.permission !== 'granted') {
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        this.app.logger.info('notification permission denied');
      }
    } else {
      this.app.logger.info('notification permission granted');
    }
  };
}

export default new BrowserNotificationsModule(
  appManager.events,
  appManager.logger('BrowserNotifications'),
);
